module.exports = __webpack_public_path__ + "static/media/default-cover.a22dee44.png";